import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Button, FeedbackBanner, Tag } from '@usacow/ds';
import { reviewCardText } from '@usacow/engines';
import { api, type ReviewCard } from '../lib/api';

const GRADES: { id: string; label: string; hint: string }[] = [
  { id: 'again', label: 'Again', hint: '<1d' },
  { id: 'hard', label: 'Hard', hint: '3d' },
  { id: 'good', label: 'Good', hint: '9d' },
  { id: 'easy', label: 'Easy', hint: '21d' },
];

export function Review() {
  const navigate = useNavigate();
  const [cards, setCards] = useState<ReviewCard[] | null>(null);
  const [i, setI] = useState(0);
  const [revealed, setRevealed] = useState(false);

  useEffect(() => {
    api
      .getReview()
      .then((r) => setCards(r.cards))
      .catch(() => setCards([]));
  }, []);

  if (!cards) return <div className="route-loading">Loading…</div>;

  if (cards.length === 0 || i >= cards.length) {
    return (
      <div className="scr scr--narrow">
        <div className="scr-head">
          <div>
            <div className="t-eyebrow">review · spaced repetition</div>
            <h1 className="scr-h">Review queue</h1>
          </div>
        </div>
        <div className="rv-empty">
          <div className="rv-empty__h">No cards due.</div>
          <p className="rv-empty__p">
            Misses from drills and problems come back here on a schedule until they transfer.
          </p>
          <Button variant="secondary" onClick={() => navigate('/app')}>
            Back to home
          </Button>
        </div>
      </div>
    );
  }

  const card = cards[i]!;
  const tag = card.misconceptionTags[0] ?? 'recall';
  const text = reviewCardText(tag);

  async function grade(g: string) {
    await api.gradeReview(card.id, g).catch(() => {});
    setRevealed(false);
    setI(i + 1);
  }

  return (
    <div className="scr scr--narrow">
      <div className="scr-head">
        <div>
          <div className="t-eyebrow">review · spaced repetition</div>
          <h1 className="scr-h">
            {cards.length - i} card{cards.length - i === 1 ? '' : 's'} due
          </h1>
        </div>
      </div>
      <div className="rv-card">
        <div className="rv-card__top">
          <Tag>{tag.replace(/-/g, ' ')}</Tag>
        </div>
        <div className="rv-card__q">{text.prompt}</div>
        {!revealed ? (
          <Button variant="secondary" style={{ width: '100%' }} onClick={() => setRevealed(true)}>
            Reveal answer
          </Button>
        ) : (
          <>
            <FeedbackBanner state="correct" title="Answer">
              {text.answer}
            </FeedbackBanner>
            <div className="rv-grade">
              {GRADES.map((g) => (
                <button key={g.id} className={`rv-g rv-g--${g.id}`} onClick={() => grade(g.id)}>
                  {g.label}
                  <small>{g.hint}</small>
                </button>
              ))}
            </div>
          </>
        )}
      </div>
    </div>
  );
}
